<template>
  <v-dialog v-model="showDialog" max-width="500px">
    <v-card>
      <v-card-title>
        Registration Links
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="links"
        >
          <template v-slot:item.action="{ item }">
            <v-btn color="blue darken-3" icon @click="copyRegistrationLink(item)">
              <i class="fas fa-clipboard"></i>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReferralLinkList',
  computed: {
    showDialog: {
      get() {
        return this.$store.state.dealers.showRegistrationLinkDialog;
      },
      set(value) {
        this.$store.dispatch('dealers/setShowRegistrationLinkDialog', value);
      },
    },
  },
  data () {
    return {
      headers: [
        {
          text: 'Dealer',
          value: 'name',
        },
        {
          text: 'Link',
          value: 'link',
        },
        {
          text: 'Action',
          value: 'action',
        },
      ],
      links: [],
    };
  },
  watch: {
    showDialog(value) {
      if (value) {
        this.getRegistrationLinks();
      }
    },
  },
  methods: {
    getRegistrationLinks() {
      this.$http('registration-links')
        .then(({ data }) => {
          this.links = data;
        });
    },
    copyRegistrationLink({ link }) {
      const clipboard = navigator.clipboard;
      clipboard.writeText(link).then(() => {
        this.$notify('success', 'Registration link copied!');
      });
    },
  },
};
</script>

<style scoped>

</style>